module.exports = __webpack_public_path__ + "static/media/main_slider_1.9f779d62.jpg";